import { render, staticRenderFns } from "./versionForm.vue?vue&type=template&id=7c34dfc6&scoped=true&"
import script from "./versionForm.vue?vue&type=script&lang=js&"
export * from "./versionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c34dfc6",
  null
  
)

export default component.exports